import { ThunkAction } from 'redux-thunk';

import RootState from 'Store/Root';

import { getQueryArgs } from '../Utils';
import { loadDesign } from 'Store/Designs/Actions';

export function loadProjectItemData(itemId: number, props: any, reload: boolean = false): ThunkAction<Promise<any>, RootState, any> {
  return (dispatch, getState) => {
    const state = getState();
    const item = state.projectItems.itemsById[itemId];

    if (!item) {
      return Promise.resolve();
    }

    const args = getQueryArgs(item, props);

    // Normalize design code to store key format.
    const key = args.designCode.toUpperCase();

    const { loadingByCode } = state.designs;

    // Chekc if teh design data is already loading
    if (!reload && loadingByCode[key]) {
      return Promise.resolve();
    }

    return dispatch(loadDesign(args.designCode, reload));
  };
}
